var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_10342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0148 22.521C21.1499 22.521 25.3128 18.3581 25.3128 13.223C25.3128 8.08784 21.1499 3.92499 16.0148 3.92499C10.8797 3.92499 6.7168 8.08784 6.7168 13.223C6.7168 18.3581 10.8797 22.521 16.0148 22.521Z",
    fill: "#FFCF64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.694 22.521C14.8291 22.521 18.992 18.3581 18.992 13.223C18.992 8.08784 14.8291 3.92499 9.694 3.92499C4.55885 3.92499 0.395996 8.08784 0.395996 13.223C0.395996 18.3581 4.55885 22.521 9.694 22.521Z",
    fill: "#FFAC27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6938 16.747C9.6038 16.747 9.5058 16.737 9.3968 16.719C9.2878 16.698 9.1818 16.671 9.0808 16.632C8.9778 16.594 8.8898 16.546 8.8168 16.488C8.7428 16.43 8.6938 16.36 8.6678 16.277L7.6998 12.777L7.2588 17.091H5.4458L6.2518 10.312C6.2648 10.165 6.3048 10.034 6.3718 9.91898C6.4388 9.80398 6.5208 9.70598 6.6168 9.62598C6.7128 9.54598 6.8168 9.48398 6.9288 9.43798C7.0398 9.39598 7.1498 9.36698 7.2588 9.35398C7.3738 9.34798 7.4968 9.35398 7.6278 9.37298C7.7588 9.39298 7.8838 9.43298 8.0018 9.49298C8.1198 9.55298 8.2278 9.63698 8.3228 9.74298C8.4178 9.84798 8.4888 9.98098 8.5338 10.141L9.6938 14.532L10.8538 10.141C10.8988 9.98098 10.9678 9.84798 11.0598 9.74298C11.1528 9.63698 11.2598 9.55398 11.3808 9.49298C11.5018 9.43198 11.6288 9.39198 11.7588 9.37298C11.8898 9.35398 12.0128 9.34798 12.1288 9.35398C12.2378 9.36698 12.3478 9.39598 12.4598 9.43998C12.5718 9.48498 12.6758 9.54698 12.7718 9.62798C12.8678 9.70798 12.9488 9.80598 13.0158 9.92098C13.0828 10.036 13.1228 10.167 13.1358 10.314L13.9418 17.093H12.1298L11.6978 12.75L10.7198 16.279C10.6938 16.362 10.6438 16.432 10.5708 16.49C10.4968 16.548 10.4088 16.595 10.3068 16.634C10.2038 16.673 10.0988 16.7 9.9898 16.721C9.8828 16.737 9.7828 16.747 9.6938 16.747Z",
    fill: "#FFE8AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_10342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.709,
    height: 25.709,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.60afe1923baad715408eed033246eeb0.svg";
export { ForwardRef as ReactComponent };